.popover-content {
    padding: 8px;
    width: 200px;
}
